import { createAxiosClient } from "@ntg/component-library/utilities";

export interface IManufacturingSiteStep {
    siteTypeId: number;
    siteTypeName: string;
    siteName: string;
    divisionName: string | null;
    siteId: number | null;
    divisionId: number | null;
    countryCode: string | null;
    startDate: string | null;
    shipDate: string | null;
}

export interface IManufacturingRoute {
    mItemID: number;
    currentStagePercentage: number | null;
    statusForOutput: string | null;
    siteSteps: IManufacturingSiteStep[];
}

export const getManufacturingRoute = async (mItemID: number): Promise<IManufacturingRoute | null> => {
    const axiosAuth = createAxiosClient("D365FO");
    try {
        const response = await axiosAuth.get<IManufacturingRoute>(
            `/ManufacturingProxy/GetRouteByMItemID/${mItemID}`,
        );
        return response.data;
    } catch {
        return null;
    }
};
